export default __webpack_public_path__ + "static/gallery-art-film-51ed2383dc6f38feb065a600634b8549.jpg";